module.exports = [{"Key":1,"Title":"First blood","Slogan":"A World of Solutions","SloganCN":"一世界方案","ImageUrl":"http://localhost:3000/static/media/timg.abafe8ea.jpg","SequenceNumber":1,"Available":true},{"Key":2,"Title":"Double kill","Slogan":"Two World of Solutions","SloganCN":"两世界方案","ImageUrl":"http://localhost:3000/static/media/timg1.fe56fb46.jpg","SequenceNumber":2,"Available":false},{"Key":3,"Title":"Triple kill","Slogan":"Three World of Solutions","SloganCN":"三世界方案","ImageUrl":"http://localhost:3000/static/media/timg2.0ddd1219.jpg","SequenceNumber":3,"Available":true}]


//////////////////
// WEBPACK FOOTER
// ./src/dummy_data/billboard.json
// module id = 1262
// module chunks = 0